export default "__VITE_ASSET__DQHjMVO$__"